<div class="review-dialog">
    <div class="dialog-header one-row">
        <div class="header-text">
            <h2>{{ dialogTitle }}</h2>
            <p class="sub" *ngIf="bestellung">
                Bestellung {{ bestellung.bestell_nr || bestellung.bestellung_extern_id }}
                <span *ngIf="bestellung.lieferant">· {{ bestellung.lieferant }}</span>
            </p>
            <p class="sub" *ngIf="!bestellung && phase === 'assign'">
                Beleg wird gelesen und einer offenen Bestellung zugeordnet.
            </p>
        </div>
        <span class="spacer"></span>
        <button mat-icon-button type="button" (click)="prevPage()" [disabled]="page <= 1" matTooltip="Vorherige Seite">
            <mat-icon>navigate_before</mat-icon>
        </button>
        <span class="page-label">{{ page }} / {{ totalPages || '…' }}</span>
        <button
            mat-icon-button
            type="button"
            (click)="nextPage()"
            [disabled]="!totalPages || page >= totalPages"
            matTooltip="Nächste Seite"
        >
            <mat-icon>navigate_next</mat-icon>
        </button>
        <button mat-icon-button type="button" (click)="close()" matTooltip="Schließen" [disabled]="saving">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="review-body">
        <div class="pdf-pane">
            <div class="pdf-loading" *ngIf="pdfLoading">PDF wird geladen …</div>
            <pdf-viewer
                *ngIf="pdfSrc"
                [src]="pdfSrc"
                [page]="page"
                [show-all]="false"
                [render-text]="true"
                [original-size]="false"
                [fit-to-page]="false"
                [autoresize]="true"
                [zoom-scale]="'page-width'"
                (after-load-complete)="onPdfLoad($event)"
                (error)="onPdfError()"
            ></pdf-viewer>
            <div class="pdf-missing" *ngIf="!pdfSrc && !pdfLoading">
                <mat-icon>picture_as_pdf</mat-icon>
                <p>PDF fehlt.</p>
            </div>
        </div>

        <div class="form-pane">
            <!-- Phase: Zuordnung -->
            <ng-container *ngIf="phase === 'assign'">
                <div class="scan-status" *ngIf="scanning">
                    <mat-spinner diameter="36"></mat-spinner>
                    <div>
                        <strong>Beleg wird gelesen …</strong>
                        <p>Zuordnung und Positionen werden vorbereitet.</p>
                    </div>
                </div>

                <div class="scan-error" *ngIf="scanFailed && !scanning">
                    <mat-icon>warning</mat-icon>
                    <div>
                        <strong>Scan nicht möglich</strong>
                        <p>{{ scanError }}</p>
                    </div>
                </div>

                <div class="scan-head" *ngIf="!scanning && draft">
                    <button
                        *ngIf="isAdmin"
                        type="button"
                        class="kind-chip json-copy-chip"
                        matTooltip="JSON kopieren"
                        (click)="copyScanJson()"
                    >
                        {{
                            selectedKind === 'credit'
                                ? 'Gutschrift'
                                : selectedKind === 'invoice'
                                  ? 'Rechnung'
                                  : 'Lieferschein'
                        }}
                        <mat-icon class="kind-chip__copy">content_copy</mat-icon>
                    </button>
                    <span *ngIf="!isAdmin" class="kind-chip">{{
                        selectedKind === 'credit'
                            ? 'Gutschrift'
                            : selectedKind === 'invoice'
                              ? 'Rechnung'
                              : 'Lieferschein'
                    }}</span>
                    <button
                        *ngIf="warnings.length"
                        mat-icon-button
                        type="button"
                        class="scan-info-btn"
                        [class.open]="scanInfoOpen"
                        [matTooltip]="scanInfoOpen ? 'Scan-Infos ausblenden' : 'Scan-Infos'"
                        (click)="scanInfoOpen = !scanInfoOpen"
                    >
                        <mat-icon>info_outline</mat-icon>
                    </button>
                </div>
                <div class="scan-info" *ngIf="scanInfoOpen && warnings.length">
                    <p *ngFor="let w of warnings">{{ w }}</p>
                </div>

                <p class="kind-label">Dokumenttyp</p>
                <div class="kind-cards">
                    <button
                        type="button"
                        class="kind-card"
                        [class.selected]="selectedKind === 'deliveryNote'"
                        [class.suggested]="suggestedKind === 'deliveryNote' && !scanFailed && !kindLocked"
                        (click)="selectKind('deliveryNote')"
                        *kienePermission="[1742, 1082]"
                    >
                        <mat-icon>local_shipping</mat-icon>
                        <span>Lieferschein</span>
                        <em *ngIf="kindLocked && selectedKind === 'deliveryNote'">gewählt</em>
                        <em *ngIf="!kindLocked && suggestedKind === 'deliveryNote' && !scanning && !scanFailed"
                            >erkannt</em
                        >
                    </button>
                    <button
                        type="button"
                        class="kind-card"
                        [class.selected]="selectedKind === 'invoice'"
                        [class.suggested]="suggestedKind === 'invoice' && !scanFailed && !kindLocked"
                        (click)="selectKind('invoice')"
                        *kienePermission="[1751, 1082]"
                    >
                        <mat-icon>euro_symbol</mat-icon>
                        <span>Rechnung</span>
                        <em *ngIf="kindLocked && selectedKind === 'invoice'">gewählt</em>
                        <em *ngIf="!kindLocked && suggestedKind === 'invoice' && !scanning && !scanFailed"
                            >erkannt</em
                        >
                    </button>
                    <button
                        type="button"
                        class="kind-card"
                        [class.selected]="selectedKind === 'credit'"
                        [class.suggested]="suggestedKind === 'credit' && !scanFailed && !kindLocked"
                        (click)="selectKind('credit')"
                        *kienePermission="[4102]"
                    >
                        <mat-icon>money</mat-icon>
                        <span>Gutschrift</span>
                        <em *ngIf="kindLocked && selectedKind === 'credit'">gewählt</em>
                        <em *ngIf="!kindLocked && suggestedKind === 'credit' && !scanning && !scanFailed"
                            >erkannt</em
                        >
                    </button>
                </div>

                <div class="assign-box" *ngIf="!scanning">
                    <div class="assign-head">
                        <p class="kind-label">Zuordnung</p>
                        <button
                            mat-stroked-button
                            type="button"
                            class="compare-btn"
                            [disabled]="!bestellung"
                            (click)="openBestellungCompare()"
                            matTooltip="Bestellung in neuem Tab öffnen zum Abgleich"
                        >
                            <mat-icon>open_in_new</mat-icon>
                            Bestellung anzeigen
                        </button>
                    </div>
                    <p class="assign-ok" *ngIf="bestellung">
                        {{ bestellung.bestell_nr || bestellung.bestellung_extern_id }}
                        <span *ngIf="bestellung.lieferant">· {{ bestellung.lieferant }}</span>
                    </p>
                    <mat-form-field appearance="outline" class="assign-field">
                        <mat-label>Bestellung wählen</mat-label>
                        <mat-hint>Vorschlag aus dem Beleg. Eine andere Bestellung kann gewählt werden.</mat-hint>
                        <mat-select
                            [(ngModel)]="selectedBestellungId"
                            [compareWith]="compareBestellungId"
                            (selectionChange)="onBestellungSelected($event.value)"
                        >
                            <mat-option *ngFor="let c of assignmentOptions" [value]="+c.bestellung_extern_id">
                                {{ c.bestell_nr || c.bestellung_extern_id }} · {{ c.lieferant
                                }}{{ candidateHint(c) }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <p class="assign-miss" *ngIf="assignmentOptions.length === 0">
                        Keine offene Bestellung erkannt – bitte eine Bestellung in der Liste wählen oder den Beleg
                        auf die Karte ziehen.
                    </p>
                </div>

                <div class="meta" *ngIf="draft && !scanning">
                    <div>
                        <span class="meta-key">Beleg-ID</span>
                        <span>{{ belegId }}</span>
                    </div>
                    <div>
                        <span class="meta-key">Nummer</span>
                        <span>{{ belegNr }}</span>
                    </div>
                    <div>
                        <span class="meta-key">Datum</span>
                        <span>{{ belegDatum }}</span>
                    </div>
                </div>

                <p class="extra-hint" *ngIf="extraFiles.length">
                    {{ extraFiles.length }} weitere Datei(en) werden danach analog hinterlegt.
                </p>
                <p class="extra-hint" *ngIf="selectedKind === 'invoice' && !scanning">
                    Danach bleiben Sie im Dialog und prüfen die Positionen wie bei betrieblichen Kosten.
                </p>
                <p class="extra-hint" *ngIf="selectedKind === 'deliveryNote' && !scanning">
                    Beim Speichern wird das PDF direkt an die Bestellung angehängt.
                </p>

                <p class="kind-label" *ngIf="matches.length && selectedKind !== 'credit'">Positionen (Scan)</p>
                <div class="match-table" *ngIf="matches.length && selectedKind !== 'credit'">
                    <div class="match-head">
                        <span>Artikel</span>
                        <span>Soll</span>
                        <span>Ist</span>
                        <span>Scan</span>
                    </div>
                    <div
                        class="match-row"
                        *ngFor="let m of matches"
                        [class.ok]="m.matched && m.qtyOk"
                        [class.warn]="m.matched && !m.qtyOk"
                        [class.miss]="!m.matched"
                    >
                        <span class="artikel" [title]="m.artikel">{{ m.artikel }}</span>
                        <span>{{ m.mengeSoll }}</span>
                        <span>{{ m.mengeIst }}</span>
                        <span>{{ m.ocrMenge != null ? m.ocrMenge : '–' }}</span>
                    </div>
                </div>
            </ng-container>

            <!-- Phase: Rechnung abgleichen (wie betriebliche Kosten) -->
            <ng-container *ngIf="phase === 'invoiceReview'">
                <div class="scan-head" *ngIf="isAdmin && draft">
                    <button
                        type="button"
                        class="kind-chip json-copy-chip"
                        matTooltip="JSON kopieren"
                        (click)="copyScanJson()"
                    >
                        Scan-JSON
                        <mat-icon class="kind-chip__copy">content_copy</mat-icon>
                    </button>
                </div>
                <p class="meta" *ngIf="draft?.extract?.source">
                    Quelle: {{ draft.extract.source }}
                    <span *ngIf="draft.extract.overallConfidence != null">
                        · Confidence {{ (draft.extract.overallConfidence * 100) | number: '1.0-0' }}%
                    </span>
                </p>

                <div class="one-row invoice-meta-row">
                    <mat-form-field appearance="outline" class="field-grow">
                        <mat-label>Rechnungsnummer</mat-label>
                        <input matInput [formControl]="rechnungsNummerCtrl" required />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="field-grow">
                        <mat-label>Rechnungsdatum</mat-label>
                        <input matInput [formControl]="rechnungsDatumCtrl" [matDatepicker]="picker" required />
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="bestell-overview" *ngIf="bestellung">
                    <div class="one-row pos-toolbar">
                        <p class="kind-label">Bestellung {{ bestellung.bestell_nr || bestellung.bestellung_extern_id }}</p>
                        <span class="spacer"></span>
                        <button
                            mat-stroked-button
                            type="button"
                            (click)="openBestellungCompare()"
                            matTooltip="Bestellung vollständig anzeigen"
                        >
                            <mat-icon>open_in_new</mat-icon>
                            Bestellung anzeigen
                        </button>
                    </div>
                    <div class="match-table" *ngIf="bestellung.positionen?.length">
                        <div class="match-head bestell-cols">
                            <span>Artikel</span>
                            <span>Soll</span>
                            <span>Ist</span>
                        </div>
                        <div class="match-row bestell-cols" *ngFor="let bp of bestellung.positionen">
                            <span class="artikel">{{ bp.artikel_me || bp.artikel }}</span>
                            <span>{{ bp.menge_soll }}</span>
                            <span>{{ bp.menge_ist || 0 }}</span>
                        </div>
                    </div>
                </div>

                <div class="one-row pos-toolbar">
                    <p class="kind-label">Rechnung abgleichen</p>
                    <span class="spacer"></span>
                    <mat-checkbox (change)="alleAnhakenInRechnung($event)">Alle in Rechnung</mat-checkbox>
                </div>
                <p class="hint">
                    „In Rechnung“ = Zuordnung zum Beleg. „Freigeben“ = für Primanota (getrennt wie früher).
                </p>

                <div class="position-list" *ngIf="invoicePruefung?.positionen?.length">
                    <div
                        class="position-block"
                        *ngFor="let p of invoicePruefung.positionen; let i = index"
                        [class.disabled]="p.primanota_id > 0"
                        [class.preis-abweichend]="isPreisAbweichend(p)"
                    >
                        <div class="position-card">
                            <div class="one-row">
                                <strong>Pos. {{ i + 1 }}</strong>
                                <span class="spacer"></span>
                                <mat-checkbox [formControl]="inRechnungCtrls[i]" (change)="initSummenKontrolle()">In Rechnung</mat-checkbox>
                                <mat-checkbox
                                    [formControl]="geprueftCtrls[i]"
                                    matTooltip="Für Primanota freigeben"
                                    >Freigeben</mat-checkbox
                                >
                                <span *ngIf="p.primanota_id > 0" class="in-primanota-status">
                                    <mat-icon class="in-primanota" matTooltip="Bereits in Primanota"
                                        >check_circle</mat-icon
                                    >
                                    In Primanota
                                </span>
                            </div>
                            <div class="artikel-name">{{ p.artikel_me || p.artikel }}</div>
                            <div class="one-row fibu-row">
                                <mat-button-toggle-group
                                    class="verbrauch-toggle"
                                    [value]="isVerbrauchPos(p) ? 'verbrauch' : 'umsatz'"
                                    [disabled]="!canEditStammFibu(p)"
                                    (change)="setVerbrauchPos(p, $event.value === 'verbrauch')"
                                >
                                    <mat-button-toggle value="umsatz">Umsatz</mat-button-toggle>
                                    <mat-button-toggle value="verbrauch">Verbrauch</mat-button-toggle>
                                </mat-button-toggle-group>
                                <mat-form-field appearance="outline" class="field-konto">
                                    <mat-label>Konto</mat-label>
                                    <input
                                        matInput
                                        readonly
                                        [value]="predictedKonto(p)"
                                        (click)="editArtikelKonto(p)"
                                        [style.cursor]="canEditStammFibu(p) ? 'pointer' : 'default'"
                                        matTooltip="Aufwandskonto am Artikelstamm – Klick zum Ändern"
                                    />
                                </mat-form-field>
                                <mat-spinner *ngIf="stammSavingBeaId != null && stammSavingBeaId === +p.bea_id" diameter="22"></mat-spinner>
                            </div>
                            <p class="fibu-hint" *ngIf="canEditStammFibu(p)">
                                Verbrauch-Flag gilt sofort am Artikelstamm; Aufwandskonto 4981/4982 erst ab 1.1.2027 (bis dahin 3400).
                            </p>
                            <div class="one-row preis-fields">
                                <mat-form-field appearance="outline" class="field-grow preis-stamm">
                                    <mat-label>Artikelstamm</mat-label>
                                    <input
                                        matInput
                                        disabled
                                        tabindex="-1"
                                        [value]="
                                            p.einzelpreis_lieferant != null
                                                ? (p.einzelpreis_lieferant | number: '1.2-2')
                                                : '–'
                                        "
                                    />
                                    <span matSuffix>€</span>
                                </mat-form-field>
                                <mat-form-field
                                    *ngIf="ocrNep(p) != null"
                                    appearance="outline"
                                    class="field-grow"
                                    [class.preis-warn]="priceCheck(p).status === 'warn'"
                                >
                                    <mat-label>Einzelpreis Beleg</mat-label>
                                    <input matInput readonly tabindex="-1" [value]="belegPreisAnzeige(p)" />
                                    <span matSuffix>€</span>
                                </mat-form-field>
                                <button
                                    *ngIf="canApplyBelegPreis(p)"
                                    mat-stroked-button
                                    type="button"
                                    class="uebernehmen-btn"
                                    (click)="applyBelegPreis(p)"
                                    matTooltip="Scan-Preis in die Bestellposition übernehmen"
                                >
                                    Übernehmen
                                </button>
                                <mat-form-field appearance="outline" class="field-grow">
                                    <mat-label>Bestellung</mat-label>
                                    <input
                                        matInput
                                        inputmode="decimal"
                                        [disabled]="p.primanota_id > 0"
                                        [ngModel]="bestellpreisText(p)"
                                        (ngModelChange)="onBestellpreisChange(p, $event)"
                                        (focus)="focusBestellpreis(p)"
                                        (blur)="blurBestellpreis(p)"
                                        [class.preis-abweichend-text]="isPreisAbweichend(p)"
                                        matTooltip="Nur diese Bestellung, nicht der Artikelstamm"
                                        placeholder="z. B. 12,50"
                                    />
                                    <span matSuffix>€</span>
                                </mat-form-field>
                                <button
                                    *ngIf="!bestellung?.untersuchungsauftrag_id"
                                    mat-icon-button
                                    type="button"
                                    [disabled]="p.primanota_id > 0"
                                    (click)="togglePreisAbweichend(p)"
                                    [matTooltip]="
                                        isPreisAbweichend(p)
                                            ? 'Preis als abweichend markiert'
                                            : 'Preis manuell als abweichend markieren'
                                    "
                                >
                                    <mat-icon [color]="isPreisAbweichend(p) ? 'warn' : ''">
                                        {{ isPreisAbweichend(p) ? 'warning' : 'warning_amber' }}
                                    </mat-icon>
                                </button>
                            </div>
                            <div class="one-row pos-fields">
                                <span class="qty">Soll {{ p.menge_soll }}</span>
                                <span class="qty">Ist {{ p.menge_ist }}</span>
                                <span class="qty" *ngIf="p.rabatt">Rabatt {{ p.rabatt | number: '1.0-1' }}%</span>
                                <span class="qty zeilensumme">
                                    Summe {{ positionZeilenNetto(p) | number: '1.2-2' }} €
                                </span>
                            </div>
                            <div
                                class="price-check"
                                *ngIf="priceCheck(p).label"
                                [class.warn]="priceCheck(p).status === 'warn'"
                                [class.unknown]="priceCheck(p).status === 'unknown'"
                            >
                                <mat-icon>{{ priceCheck(p).status === 'warn' ? 'warning' : 'info' }}</mat-icon>
                                <span>{{ priceCheck(p).label }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="hint" *ngIf="!invoicePruefung?.positionen?.length">Keine Positionen geladen.</p>

                <p class="kind-label">Summen-Kontrolle</p>
                <p class="hint">
                    Netto, MwSt und Brutto vom Beleg – vorbelegt aus Scan bzw. Positionssumme, bei Bedarf korrigieren.
                </p>
                <div class="totals">
                    <div class="totals-row">
                        <span>Summe Positionen (in Rechnung)</span>
                        <strong>{{ sumNettoInRechnung | number: '1.2-2' }} €</strong>
                    </div>
                    <div class="totals-row" *ngIf="extractNetto != null">
                        <span>Scan Netto</span>
                        <strong>{{ extractNetto | number: '1.2-2' }} €</strong>
                    </div>
                    <div
                        class="price-check"
                        *ngIf="summenAbweichung.status === 'warn'"
                        [class.warn]="true"
                    >
                        <mat-icon>warning</mat-icon>
                        <span>{{ summenAbweichung.label }}</span>
                    </div>
                    <div class="totals-row" *ngIf="extractBrutto != null">
                        <span>Scan Brutto</span>
                        <strong>{{ extractBrutto | number: '1.2-2' }} €</strong>
                    </div>
                    <div class="one-row kontroll-row">
                        <mat-form-field appearance="outline" class="field-grow">
                            <mat-label>Netto / Zwischensumme</mat-label>
                            <input
                                matInput
                                inputmode="decimal"
                                [ngModel]="kontrollNetto"
                                (ngModelChange)="parseKontrollNumber($event, 'netto')"
                                placeholder="z. B. 2259,20"
                            />
                            <span matSuffix>€</span>
                        </mat-form-field>
                        <mat-icon
                            class="kontroll-icon"
                            [class.ok]="kontrollNettoStatus === 'ok'"
                            [class.warn]="kontrollNettoStatus === 'warn'"
                            *ngIf="kontrollNettoStatus !== 'idle'"
                            >{{ kontrollNettoStatus === 'ok' ? 'check_circle' : 'cancel' }}</mat-icon
                        >
                    </div>
                    <div class="one-row kontroll-row">
                        <mat-form-field appearance="outline" class="field-grow">
                            <mat-label>MwSt</mat-label>
                            <input
                                matInput
                                inputmode="decimal"
                                [ngModel]="kontrollMwst"
                                (ngModelChange)="parseKontrollNumber($event, 'mwst')"
                                placeholder="z. B. 429,25"
                            />
                            <span matSuffix>€</span>
                        </mat-form-field>
                        <mat-icon
                            class="kontroll-icon"
                            [class.ok]="kontrollMwstStatus === 'ok'"
                            [class.warn]="kontrollMwstStatus === 'warn'"
                            *ngIf="kontrollMwstStatus !== 'idle'"
                            >{{ kontrollMwstStatus === 'ok' ? 'check_circle' : 'cancel' }}</mat-icon
                        >
                    </div>
                    <div class="one-row kontroll-row">
                        <mat-form-field appearance="outline" class="field-grow">
                            <mat-label>Brutto / Endsumme</mat-label>
                            <input
                                matInput
                                inputmode="decimal"
                                [ngModel]="kontrollBrutto"
                                (ngModelChange)="parseKontrollNumber($event, 'brutto')"
                                placeholder="z. B. 2688,45"
                            />
                            <span matSuffix>€</span>
                        </mat-form-field>
                        <mat-icon
                            class="kontroll-icon"
                            [class.ok]="kontrollBruttoStatus === 'ok'"
                            [class.warn]="kontrollBruttoStatus === 'warn'"
                            *ngIf="kontrollBruttoStatus !== 'idle'"
                            >{{ kontrollBruttoStatus === 'ok' ? 'check_circle' : 'cancel' }}</mat-icon
                        >
                    </div>
                </div>
            </ng-container>

            <span class="spacer"></span>

            <div class="actions">
                <ng-container *kienePermission="[1832, 1082]">
                    <button
                        *ngIf="phase === 'invoiceReview'"
                        mat-stroked-button
                        type="button"
                        (click)="openPrimanotaExportVorschau()"
                    >
                        <mat-icon>preview</mat-icon>
                        Primanota-Vorschau
                    </button>
                </ng-container>
                <button mat-stroked-button type="button" (click)="close()" [disabled]="saving">Abbrechen</button>
                <button
                    mat-flat-button
                    color="primary"
                    type="button"
                    (click)="confirm()"
                    [disabled]="!canConfirm"
                >
                    <mat-icon>{{ phase === 'invoiceReview' ? 'save' : 'arrow_forward' }}</mat-icon>
                    {{ confirmLabel }}
                </button>
            </div>
        </div>
    </div>
</div>
